import { Component, Input } from "@angular/core";
import { MitsIconName } from "./interfaces/mits-icon";
import { MitsIconComponent } from "./mits-icon.component";

@Component({
  selector: "mits-icon",
  template: '<span>{{ name }}</span>',
})
export class MockMitsIconComponent implements Partial<MitsIconComponent> {
  @Input() name: MitsIconName;
}
